import { useContext, useEffect } from "react";
import { Loading } from "../shared/Loading/Loading";
import { ConfigitContext } from "../ConfigitProvider";
import { useParams } from "react-router-dom";
import { useGetUserSavedSearchCriteriaQuery } from "../../models/GQLGeneratedModels";
import { jsx as _jsx } from "react/jsx-runtime";
var LoadUserSavedSearch = function (props) {
    var _a = useContext(ConfigitContext), setManufacturerProduct = _a.setManufacturerProduct, updateConfigitCriteria = _a.updateConfigitCriteria, layerConfigMasterData = _a.layerConfigMasterData, sections = _a.sections;
    var params = useParams();
    if (!params.UserSavedSearchGuid) {
        throw Error('Empty UserSavedSearchGuid');
    }
    var _b = useGetUserSavedSearchCriteriaQuery({ variables: { UserSavedSearchGuid: params.UserSavedSearchGuid } }), data = _b.data, error = _b.error, loading = _b.loading;
    useEffect(function () {
        if (data && layerConfigMasterData !== null && layerConfigMasterData !== void 0 && layerConfigMasterData.length && sections.length) {
            var configitCriteriaString = atob(data.UserSavedSearch[0].SearchCriteriaData);
            var configitCriteria = JSON.parse(configitCriteriaString);
            if (configitCriteria.manufacturerProduct.length)
                setManufacturerProduct(configitCriteria.manufacturerProduct);
            else {
                updateConfigitCriteria(configitCriteria.variableAssignments, configitCriteria.layers, configitCriteria.excludedLayerIds);
            }
        }
    }, [data, layerConfigMasterData, !sections.length]); // !sections.length should only trigger this effect when sections is undefined and populated not everytime it changes
    return /*#__PURE__*/ _jsx("div", { className: "d-flex justify-content-center align-items-center loading-spinner-full", children: /*#__PURE__*/ _jsx(Loading, {}) });
};
export default LoadUserSavedSearch;
